export const GET_REPORTS = "GET_REPORTS"
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS"
export const GET_REPORTS_FAIL = "GET_REPORTS_FAIL"

export const TOGGLE_LOADING_REPORTS = "TOGGLE_LOADING_REPORTS"
export const DELETE_REPORT = "DELETE_REPORT"